<template>
  <!-- ini adalah card untuk kelas yang harus diselesaikan -->
  <v-card v-if="type == 'enroll'" style="height:100%">
    <div>
      <v-img
        contain
        class="white--text align-end"
        height="200px"
        :src="item.kelas.cover ? item.kelas.cover : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-success.jpg'"
      ></v-img>
      <div
        :class="
          item.is_complete
            ? 'arrow-left-green'
            : !item.is_sync
            ? 'arrow-left-blue'
            : $tools.checkKelasRunningWithTime(serverTime, item)
            ? 'arrow-left-blue'
            : $tools.parseIsAfter(serverTime, item.waktu_selesai) && item.is_complete
            ? 'arrow-left-green'
            : 'arrow-left-red'
        "
      ></div>
      <div
        :class="
          item.is_complete
            ? 'label-green'
            : !item.is_sync
            ? 'label-blue'
            : $tools.checkKelasRunningWithTime(serverTime, item)
            ? 'label-blue'
            : $tools.parseIsAfter(serverTime, item.waktu_selesai) && item.is_complete
            ? 'label-green'
            : 'label-red'
        "
      >
        {{
          item.is_complete
            ? "Tuntas"
            : !item.is_sync
            ? "Dalam proses"
            : $tools.checkKelasRunningWithTime(serverTime, item)
            ? "Sedang Berlangsung"
            : $tools.parseIsBefore(serverTime, item.waktu_mulai)
            ? "Belum dimulai"
            : "Tidak Tuntas"
        }}
      </div>
    </div>

    <v-card-subtitle class="black--text font-weight-bold mb-0 pb-1">{{ title }} </v-card-subtitle>
    <v-card-subtitle class="black--text my-0 py-0">
      <v-icon size="15" color="primary">mdi-clock-outline</v-icon>
      <span class="ml-3 font-weight-bold caption">{{ pVal(item, "waktu_mulai") | toD }} - {{ pVal(item, "waktu_selesai") | toD }}</span>
    </v-card-subtitle>
    <v-card-text class="black--text mt-1 pt-1 mb-0 py-0">
      <v-row>
        <v-col class="mb-0 py-0" cols="1">
          <v-icon size="15" class="mt-n1" color="success">mdi-check</v-icon>
        </v-col>
        <v-col class="my-0 pt-0 body-2" cols="11">
          {{ item.kelas.keterangan }}
        </v-col>
      </v-row>
      <p v-if="!item.is_sync" class="mt-2 pl-2 caption blue lighten-4 pa-1">
        Registrasi Anda masih dalam proses pengaktifan. Bila status masih dalam proses lebih dari 5 menit, silakan logout dan login kembali dalam 30 menit kedepan
      </p>
    </v-card-text>

    <v-card-actions class="mt-0 pt-0">
      <v-row>
        <v-col cols="12" class="my-0 py-1">
          <m-button v-if="$tools.parseIsBefore(serverTime, item.waktu_mulai)" disabled class="my-2" isBlock depressed color="grey" textButton="Belum dimulai"></m-button>
          <!-- lms url tersedia belum tersinkron-->
          <m-button
            v-else-if="!item.is_sync"
            isBlock
            depressed
            icon="mdi-refresh"
            color="primary"
            textButton="Muat Ulang"
            action="reloadKelasku"
            @reloadKelasku="reloadKelasku()"
          ></m-button>
          <!-- lms url tersingkron-->
          <m-button
            v-else
            isBlock
            :disabled="cekStatusLMS(item)"
            depressed
            :icon="item.is_sync ? 'mdi-link' : 'mdi-timelapse'"
            color="primary"
            textButton="Tautan Fasilitasi"
            action="toLMS"
            @toLMS="toLMS(item.kelas_moodle)"
          ></m-button>
        </v-col>
        <v-col cols="12" class="my-0 py-1" v-if="item.kategori_id == 1">
          <!-- slot ini hanya muncul jika pengguna belum melewati maksimal daftar/ubah mapel -->
          <!-- label menjadi ubah mapel jika statusnya belum mulai atau sedang berlangsung -->
          <!-- label menjadi daftar ulang jika statusnya tuntas atau tidak tuntas dan belum melewati batas pendaftaran  -->
          <m-button
            isBlock
            depressed
            :disabled="!this.current_user.is_daftar_p3k_umum && !this.current_user.is_daftar_p3k_kejuruan"
            color="warning"
            :textButton="$tools.parseIsAfter(serverTime, item.waktu_selesai) ? 'Pilih Mapel' : 'Ubah Mapel'"
            action="ubahMapel"
            @ubahMapel="$emit('ubahMapel')"
          ></m-button>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
  <!-- ini adalah card untuk kelas yang bisa dipilih -->

  <v-card v-else-if="type == 'pilihJenis'" style="height:100%">
    <div>
      <v-img
        contain
        class="white--text align-end"
        height="200px"
        :src="item.cover ? item.cover : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-success.jpg'"
      ></v-img>
      <div class="arrow-left-blue"></div>
      <div class="label-blue">
        Tersedia
      </div>
    </div>

    <v-card-title class="blue--text">{{ title }} </v-card-title>

    <v-card-subtitle class="black--text" v-if="item.wkt_mulai">
      <v-icon size="15" color="primary">mdi-clock-outline</v-icon>
      {{ pVal(item, "wkt_mulai") | toD }} -
      {{ pVal(item, "wkt_selesai") | toD }}
    </v-card-subtitle>

    <v-card-text class="black--text my-1 py-1" v-if="isSyarat">
      <span class="font-weight-bold">Syarat Pendaftaran</span>
      <v-row v-for="syarat in syarats" :key="syarat.index">
        <v-col class="mb-0 py-0" cols="1">
          <v-icon size="15" class="mt-n1" :color="syarat.status ? 'success' : 'error'">{{ syarat.status ? "mdi-check" : "mdi-close" }}</v-icon>
        </v-col>
        <v-col class="my-0 py-0 body-2" cols="11">
          {{ syarat.keterangan }}
        </v-col>
      </v-row>
      <div class="pt-3">Data berdasarkan pada <strong>SIMPKB</strong>, jika terdapat kekeliruan data dengan kondisi aslinya mohon untuk memperbarui data Anda.</div>
    </v-card-text>

    <v-card-actions>
      <m-button
        v-if="current_instansi.is_rilis"
        class="my-2"
        :disabled="disabled"
        isBlock
        depressed
        color="primary"
        :textButton="disabled ? 'Tidak memenuhi syarat' : 'Daftar'"
        action="toEnroll"
        @toEnroll="$emit('toEnroll', item)"
      ></m-button>
      <m-button v-else class="my-2" disabled isBlock depressed color="primary" textButton="Pendaftaran belum dibuka"></m-button>
    </v-card-actions>
  </v-card>
  <span v-else></span>
</template>

<script>
//@group PPPK Feature
export default {
  name: "course-pendaftaran",
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary"
    },
    type: {
      type: String,
      default: "pilih"
    },
    isJadwalUlang: {
      type: Boolean,
      default: false
    },
    isModeKelas: {
      type: Boolean,
      default: false
    },
    isSyarat: {
      type: Boolean,
      default: true
    },
    syarats: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: "Klik"
    },
    serverTime: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      cekKuota: null,
      reloadKuota: false,
      t: false,
      panel: [1]
    };
  },
  methods: {
    cekStatusLMS(item) {
      // jika tersingkron tombol tidak disabled
      if (!item.is_sync) {
        return true;
      } else if (this.current_instansi.is_tutup) {
        return true;
      } else {
        return false;
      }
    },
    ubahJadwal(item) {
      this.$emit("ubahJadwal", item);
    },
    reloadKelasku() {
      this.$emit("reload");
    },
    toLMS(val) {
      if (this.item.kelas.is_deleted == 1) {
        this.$emit("toPerawatan");
      } else {
        window.open(val.lms_url, "_blank");
      }
    }
  },
  computed: {
    disabled() {
      var statusSyarat = [];
      this.syarats.forEach(syarat => {
        statusSyarat.push(syarat.status);
      });
      if (statusSyarat.includes(false)) {
        return true;
      } else {
        return false;
      }
    },
    statusKelas() {
      if (this.item.is_complete) {
        return "Tuntas";
      } else if (!this.item.is_sync) {
        return "Dalam Proses";
      } else if (this.$tools.checkKelasRunningWithTime(this.serverTime, this.item)) {
        return "Sedang Berlangsung";
      } else if (this.$tools.parseIsBefore(this.serverTime, this.item.waktu_mulai)) {
        return "Belum dimulai";
      } else {
        return "Tidak tuntas";
      }
    }
  }
};
</script>

<style>
.label-blue {
  background-color: #007bff;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-blue {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid #007bff;
}

.label-red {
  background-color: #e61d4c;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-red {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid rgb(170, 0, 0);
}

.label-green {
  background-color: rgb(61, 187, 82);
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-green {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid rgb(10, 143, 54);
}

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 40px;
}
</style>
